import ContentDetails from './ContentDetails';

export default ContentDetails;
